import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import { createApp } from "vue";

import ThePublicApplicationsList from "@/components/district-applications-list/components/public/ThePublicApplicationsList.vue";
import { presets } from "@/constants/primevuePresets.ts";

const publicDistrictApplicationsListApp = createApp(ThePublicApplicationsList);
const pinia = createPinia();

publicDistrictApplicationsListApp.use(pinia);
publicDistrictApplicationsListApp.use(PrimeVue, {
    theme: {
        preset: presets,
        options: {
            darkModeSelector: false,
        },
    },
});

publicDistrictApplicationsListApp.use(ToastService);
publicDistrictApplicationsListApp.mount("#public-district-applications-list-app");

export default publicDistrictApplicationsListApp;
